import { SYNC_KEY_COSTOS_EQUIPOS } from "../../../constantes";
import { CostosPlataformaService, TarifaEquipoItem } from "../../generated/grpc/plataforma_costos_pb";
import { CostoEquipoResponse } from "../../response/costos/CostoEquipoResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Equipos y su precio (`CostosPlataformaService`, gRPC). Pipeline los reusa para cotizar. */
export class CostoEquipoListService extends ServiceGetListBase<CostoEquipoResponse> {
  static readonly instance = new CostoEquipoListService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_COSTOS_EQUIPOS;

  /** gRPC-Web (`ListEquipos`): no eliminados, por orden. */
  protected async fetchItems(): Promise<CostoEquipoResponse[]> {
    const r = await grpcCall(() => grpcClient(CostosPlataformaService).listEquipos({}));
    return r.items.map(toCostoEquipoResponse);
  }
}

/** Mensaje gRPC del equipo → respuesta. */
export function toCostoEquipoResponse(t: TarifaEquipoItem): CostoEquipoResponse {
  return {
    id: t.id,
    isEliminado: false,
    nombre: t.nombre,
    unidad: t.unidad,
    precio: Number(t.precio),
    nota: t.nota ?? null,
    orden: t.orden,
  };
}
